import SalesforceBulkReaderNode from './types/salesforce-bulk-reader';
import SalesforceBulkWriterNode from './types/salesforce-bulk-writer';
import SalesforceReaderNode from './types/salesforce-reader';
import SalesforceV2ReaderNode from './types/salesforce-v2-reader';
import SalesforceWriterNode from './types/salesforce-writer';

export const salesForceNodes = {
  salesforceReader: SalesforceReaderNode,
  salesforceWriter: SalesforceWriterNode,
  salesforceBulkWriter: SalesforceBulkWriterNode,
  salesforceBulkReader: SalesforceBulkReaderNode,
  salesforceV2Reader: SalesforceV2ReaderNode,
};
